import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { styled } from "@mui/system";

const SectionContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "60vh", // Full viewport height
  backgroundColor: "black",
  backgroundImage: 'url("/assets/section-3-main-bg-img.png")',
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  color: "white",
  padding: "4em 0em", // General padding
  [theme.breakpoints.down("md")]: {
    padding: "0em 1.5em",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "2em 0em",
  },
}));

const sections = [
  {
    title: "Who We Are",
    text: "Urban Casa is a premier custom home builder focused on creating innovative, sustainable, and personalized living spaces. With over 4 years in the construction industry, we’ve built a reputation for excellence in design, craftsmanship, and customer service. Every project we take on is a partnership—our goal is to bring your dream to life with professionalism and care.",
  },
  {
    title: "Our Commitment",
    text: "At Urban Casa, commitment isn’t just a word — it’s the core of everything we do. We promise honest communication, reliable timelines, and unmatched craftsmanship in every project we take on. Whether it's your first home or a commercial venture, we treat it with the same passion and responsibility. Your peace of mind matters, and we go an extra mile to ensure a smooth, transparent, and stress-free experience from start to finish.",
  },
  {
    title: "Why Choose Us",
    text: "With Urban Casa, you’re not just hiring a builder — you’re partnering with experts who understand the unique needs of Australian living. We’re fully licensed, professionally insured, and deeply experienced in delivering projects that exceed expectations. Our commitment to high-quality materials, sustainable practices, and customer satisfaction sets us apart. We combine creativity, compliance, and construction excellence — making us the smart choice for your next project.",
  },
];

const Section_3 = () => {
  return (
    <SectionContainer>
      <Grid container spacing={6} justifyContent="center">
        {sections.map((section, index) => (
          <Grid item xs={12} sm={10} md={6} key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: { xs: "90%", sm: "90%", md: "80%" }, // Responsive width
                textAlign: { xs: "center", md: "left" }, // Center on small screens
                paddingLeft:{ xs: "1em"},
                margin:"auto"
              }}
            >
              {/* Green Bullet Point + Title */}
              <Typography
                sx={{
                  color: "#70B22F",
                  fontWeight: "bold",
                  fontSize: { xs: "1.6rem", sm: "1.8rem", md: "1.6vw" }, // Different sizes
                  textAlign: { xs: "start", md: "left" }, // Responsive alignment
                }}
              >
                ♦ {section.title}
              </Typography>

              {/* White Body Text */}
              <Typography
                sx={{
                  fontSize: { xs: "1.12rem", sm: "1.4rem", md: "1.1vw" }, // Responsive sizes
                  lineHeight: { xs: 1.6, sm: 1.7, md: 1.8 }, // Responsive line height
                  textAlign: { xs: "justify", md: "justify",lg:"justify" }, // Center on small screens
                  
                }}
              >
                {section.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </SectionContainer>
  );
};

export default Section_3;
